<div class="mat-list-item" *ngIf="canAccessLegacy">
  <a siteUsageTracker [logCategory]="'sideNav'" [logName]="'SwitchToLegacyView'" href="{{links[0]?.url}}" [target]="'_blank'">
    {{links[0]?.text}}
  </a>
</div>

<div class="mat-list-item">

  <a siteUsageTracker [logCategory]="'sideNav'" [logName]="'DownloadResourceLink'" href="{{links[1]?.url}}" target="_blank">{{links[1]?.text}}</a><br />
  <ul>
    <li>
      <a siteUsageTracker [logCategory]="'sideNav'" [logName]="'ThreeGQuickReferenceLink'" href="{{links[2]?.url}}" target="_blank">{{links[2]?.text}}</a>
    </li>
    <li>
      <a siteUsageTracker [logCategory]="'sideNav'" [logName]="'SelfInstallGuideLink'" href="{{links[3]?.url}}" target="_blank">{{links[3]?.text}}</a>
    </li>
  </ul>
</div>

<div class="mat-list-item">
  <a siteUsageTracker [logCategory]="'sideNav'" [logName]="'CustomerServiceLink'" href="{{links[4]?.url}}" target="_blank">{{links[4]?.text}}</a>
</div>
